import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>CISAC General Assembly 2026</h3>
          <p>Celebrating 100 Years in Paris</p>
          <p className="footer-date">June 4, 2026</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/schedule">Schedule</a></li>
            <li><a href="/accommodation">Accommodation</a></li>
            <li><a href="/welcome-guide">Welcome Guide</a></li>
            <li><a href="/contacts">Contacts</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>Registration & Accommodation:</p>
          <p>
            <a href="mailto:2026ga@cisac.org">2026ga@cisac.org</a>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} CISAC. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
